const DEFAULT_OFFSET = 120;

const getScrollTop = (element: HTMLElement) => {
  const top = element.getBoundingClientRect().top - document.body.getBoundingClientRect().top;
  return top - DEFAULT_OFFSET;
};

export const scrollToElement = (element: HTMLElement | null) => {
  if (!element) return;
  window.scrollTo({ behavior: "smooth", top: getScrollTop(element) });
};
